import React, { useEffect, useMemo, useState } from "react";
import { message, Modal } from "antd";
import { GetTeamMemberListAPI } from "../../../../Redux/teamMember";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";
import {
  DefaultProfileImage,
  getFullAwsUrl,
  ROLE,
  useDebounce,
} from "../../../../../helpers/utils";
import { useParams } from "react-router-dom";
import { AddOrderDispatchTeamAPI } from "../../../../Redux/orders";
import { BtnLoader } from "../../../../../Components/Components";
import FullScreenLoader from "../../../../Components/FullScreenLoader";

interface TeamMember {
  id: number;
  name: string;
  avatar: string;
  checked?: boolean;
}

interface Props {
  visible: boolean;
  onClose: () => void;
  selectedLoadData?: any;
  setSelectedLoadData?: any;
  employeList?: any;
  onSave?: (payload: any, callback: (data: any) => void) => void;
}

const AddDispatchTeamModal: React.FC<Props> = ({
  visible,
  onClose,
  selectedLoadData,
  setSelectedLoadData,
  employeList,
  onSave,
}) => {
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const { teamMemberList } = useAppSelector(
    (state: RootState) => state.teamMember,
  );
  const { addDispatchTeamLoading, getTeamMemberLoading } = useAppSelector(
    (state: RootState) => state.loading,
  );
  const [selectedTeamMembers, setSelectedTeamMembers] = useState<number[]>(
    employeList ?? [],
  );
  const [forAllLoads, setForAllLoads] = useState(false);
  const [employeePage, setEmployeePage] = useState(1);
  const [hasMoreEmployee, setHasMoreEmployee] = useState(true);
  const [employeeSearch, setEmployeeSearch] = useState("");
  const debouncedEmployeeSearch = useDebounce(employeeSearch, 300);

  const teamPayload = useMemo(
    () => ({
      page: employeePage,
      limit: 25,
      search: debouncedEmployeeSearch,
      roleKey: [ROLE.DISPATCH,ROLE.DISPATCH_MANAGER],
    }),
    [employeePage, debouncedEmployeeSearch],
  );

  useEffect(() => {
    dispatch(GetTeamMemberListAPI(teamPayload, setHasMoreEmployee));
  }, []);

  const handleCheckboxChange = (id: number) => {
    setSelectedTeamMembers((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };
  const handleSaveEmployee = () => {
    // if (selectedTeamMembers?.length === 0) {
    //   message.error("Please select at least one team member");
    //   return;
    // }
    const payload = {
      order_id: id,
      load_id: selectedLoadData?._id,
      employee_ids: selectedTeamMembers,
      for_all_loads: forAllLoads,
    };
    const handleSuccessClose = (data: any) => {
      const findCurrentLoad = data?.load_id?.find(
        (elem: any) => elem?._id == selectedLoadData?._id,
      );
      if (findCurrentLoad) {
        const newSelectedLoad = {
          ...selectedLoadData,
          employee_ids: findCurrentLoad?.employee_ids,
        };
        setSelectedLoadData(newSelectedLoad);
      }
      onClose();
    };
    if (onSave) {
      onSave({ ...payload }, handleSuccessClose);
    } else {
      dispatch(AddOrderDispatchTeamAPI({ ...payload }, handleSuccessClose));
    }
  };
  return (
    <Modal
      title={<div className="text-center fs-4 fw-bold">Add Dispatch Team</div>}
      open={visible}
      onCancel={onClose}
      width="33.75rem"
      centered
      footer={
        <div>
          {teamMemberList?.length > 0 ? (
            <div className="my-3 d-flex align-items-center justify-content-center gap-2 cursor-pointer" onClick={() => setForAllLoads((prev) => !prev)}>
              <input
                checked={forAllLoads}
                onChange={() => setForAllLoads((prev) => !prev)}
                onClick={(e) => e.stopPropagation()}
                type="checkbox"
                className="form-check-input dispatch-checkbox mt-0"
              />
              <span className="fw-normal fs-6 text-start">
                Add Same Dispatch Team for all Loads of this Order
              </span>
            </div>
          ) : (
            ""
          )}

          <div className="d-flex justify-content-center gap-4">
            <button
              type="button"
              className="btn btn-lg btn-outline-secondary min-w-126"
              onClick={onClose}
            >
              CLOSE
            </button>

            <button
              type="button"
              className="btn btn-lg min-w-126 btn-dark"
              onClick={handleSaveEmployee}
              disabled={addDispatchTeamLoading}
            >
              {addDispatchTeamLoading ? <BtnLoader /> : "SAVE"}
            </button>
          </div>
        </div>
      }
      className="custom-modal dispatchTeamModal"
    >
      <div className="dispatch-team-list">
        {getTeamMemberLoading ? (
          <FullScreenLoader />
        ) : teamMemberList?.length > 0 ? (
          teamMemberList?.map((member: any) => (
            <div
              key={member?._id}
              onClick={() => handleCheckboxChange(member?._id)}
              className="d-flex align-items-center justify-content-between dispatch-user-row cursor-pointer"
            >
              <div className="d-flex align-items-center gap-3">
                <img
                  src={
                    member?.profile_pic
                      ? getFullAwsUrl(member?.profile_pic)
                      : DefaultProfileImage
                  }
                  alt={member?.name}
                  className="dispatch-avatar"
                  onError={(e: any) => {
                    e.target.onerror = null;
                    e.target.src = DefaultProfileImage;
                  }}
                />

                <span className="dispatch-name">{member?.name}</span>
              </div>

              <input
                type="checkbox"
                checked={selectedTeamMembers.includes(member?._id)}
                onChange={() => handleCheckboxChange(member?._id)}
                onClick={(e) => e.stopPropagation()} // Prevent double toggle
                className="form-check-input dispatch-checkbox"
              />
            </div>
          ))
        ) : (
          <div className="text-center p-2 text-949494">
            You don't have any dispatch team member yet
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AddDispatchTeamModal;
